//Copyright © 2021 Cloudcontainers b.v. - All Rights Reserved

import { createStore } from 'redux';

import rootReducer from './reducers/index';

export default createStore(
	rootReducer
);
